import { Box } from "@chakra-ui/react";
import HeaderTable from "./HeaderTable";
import { Empty } from "antd";
import FooterTable from "./FooterTable";
import ItemTable from "./ItemTable";
import { OrcamentoCotacaoItem } from "features/orcamento/typings";

interface TableItensCotadosProps {
  onCheckAll: () => void;
  onCheckItem: (itemId: string, aprovado: boolean) => void;
  data?: OrcamentoCotacaoItem[];
  isLoading?: boolean;
  isCheckedAll: boolean;
  isIndeterminate: boolean;
  checkedItems: string[];
}

export default function TableItensCotados({
  onCheckAll,
  onCheckItem,
  isLoading,
  data,
  isCheckedAll,
  isIndeterminate,
  checkedItems,
}: TableItensCotadosProps) {
  let total = data?.reduce(
    (accumulator, currentValue) => accumulator + currentValue.total!,
    0
  );
  return (
    <Box>
      <HeaderTable
        isCheckedAll={isCheckedAll}
        onCheckAll={onCheckAll}
        isIndeterminate={isIndeterminate}
      />

      {!isLoading && !data?.length ? (
        <Box mt={4}>
          <Empty description="Sem itens." />{" "}
        </Box>
      ) : null}

      {!isLoading && data?.length ? (
        <>
          {data?.map((item) => (
            <ItemTable
              onCheckItem={onCheckItem}
              key={item.id}
              item={item}
              checked={checkedItems.includes(item.id!)}
            />
          ))}
        </>
      ) : null}

      {data?.length ? (
        <FooterTable totalItens={data?.length} total={total} />
      ) : null}
    </Box>
  );
}
